import React, { useState, useEffect } from 'react'
import Header from '../Layout/Header'
import './css/wallet-dashboard.css';
import Sidebar from "../Layout/Sidebar";
import { Layout } from "antd";
import CustomHeader from "../Layout/Header";
import companyIcon from './img/company-icon.svg';
import wallelBalicon from './img/balance-icon-60x60.svg';
import InfoIcon from './img/info-icon-white.svg';
import topupWalletIcon from './img/topup-wallet-icon.svg';
import distriHistory from './img/distri_history.svg';
import distriIcon from './img/distri_icon.svg';
import purchaseIcon from './img/purchase_icon.svg';
import redemIcon from './img/redem_icon.svg';
import LinkArrowRight from './img/arrow-right.svg';
import LockIcon from './img/lock-icon.svg';
import ctaStripIcon from './img/plan-list-icon.svg';
import ActivePlanPopupimg from './img/ActivePlanPopup-img.svg';
import axios from 'axios';
import { dataUser } from '../Helpers/util';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import SwLoader from '../Common/SwLoader/SwLoader';
import SwButton from '../Common/SwButtons/SwButtons';


const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

function CompanyWallet() {
    const [walletBalance, setWalletBalance] = useState([]);
    const [topUps, setTopUps] = useState([]);
    const [distribution, setDistribution] = useState([]);
    const [userRedemption, setUserRedemption] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const [spinnerDist, setSpinnerDist] = useState(true)
    const [spinnerUser, setSpinnerUser] = useState(true)

    const navigate = useNavigate();

     const [collapsed, setCollapsed] = useState(true); 
       const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
      };

    // const source = axios.CancelToken.source();

    useEffect(() => {
        const getCurrentWalletBalance = async () => {
            try {
                const authToken = localStorage.getItem("token");
                const res = await axiosInstance.get(
                    `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/getCompanyWalletBalance/${UserObj ? UserObj.company_id : null}`,
                    {
                        headers: {
                            Authorization: `${authToken}`,
                        },
                        // cancelToken: source.token,
                    }
                );
                if (res.data.statusValue === 200) {
                    setWalletBalance(res.data.balance);
                }
            } catch (error) {
                console.error("Error occurred while fetching wallet balance:", error);
            }
        };

        const getTopUpsLimitedData = async () => {
            try {
                setSpinner(true);
             
                const res = await axiosInstance.get(
                    `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/getCompanyWalletTopUps/${UserObj ? UserObj.company_id : null}/3`,
                );
                if (res.data.statusValue === 200) {
                    setTopUps(res.data.transactions);
                }
            } catch (error) {
                console.error("Error occurred while fetching top-ups:", error);
            } finally {
                setSpinner(false);
            }
        };

        const getDistributionData = async () => {
            try {
                setSpinnerDist(true);
      
                const res = await axiosInstance.get(
                    `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/getCompanyPointsCredit/${UserObj ? UserObj.company_id : null}/3/0`,
                 
                );
                if (res.data.statusValue === 200) {
                    setDistribution(res.data.transactions);
                }
            } catch (error) {
                console.error("Error occurred while fetching distribution data:", error);
            } finally {
                setSpinnerDist(false);
            }
        };

        const getUserRedemptionData = async () => {
            try {
                setSpinnerUser(true);
      
                const res = await axiosInstance.get(
                    `${process.env.REACT_APP_API_GATEWAYS_URL}commerce/wallet/v2/company/getCompanyPointsRedemption/${UserObj ? UserObj.company_id : null}/3/0`,
                  
                );
                if (res.data.statusValue === 200) {
                    setUserRedemption(res.data.transactions);
                }
            } catch (error) {
                console.error("Error occurred while fetching user redemption data:", error);
            } finally {
                setSpinnerUser(false);
            }
        };

        // Call the functions to fetch data
        const fetchData = async () => {
            await getCurrentWalletBalance();
            await getTopUpsLimitedData();
            await getDistributionData();
            await getUserRedemptionData();
        };

        fetchData();

        // Cleanup function to cancel any ongoing requests
    

    }, []);





    return (<>
       <Layout>
      
      <Sidebar collapsed={collapsed} />

      <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      

      <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>

            <div className="PageContent">
            <div className='WalletDashboard_Page'>


                <div className='row'>
                    
                    <div className='col-md-5'>
                        <div className='WalletBalanceCard'>
                            <div className='d-flex justify-content-between'>
                                <div className='WalletBalance_left'>
                                    <div className='SwHeading SwTextWhite'>
                                        <h2>Company Wallet <br /> balance</h2>
                                    </div>

                                    <div>
                                        <div className='WalletCard-companyName d-flex '>
                                            <img src={companyIcon} className='pr-2' />
                                            <span>{UserObj ? UserObj.company_name : ""}</span>
                                        </div>
                                        <div className='Topup_cta'>
                                            <SwButton
                                                variant='light'
                                                block='yes'
                                                onClick={() => navigate("/bank-details")}
                                                icon={<i className='bi bi-arrow-right' />}
                                                iconPosition='end'
                                            >
                                             Top-up wallet   
                                            </SwButton>
                                        </div>
                                    </div>

                                </div>
                                <div className='walletBalanceBlock'>
                                    <div className='walletBalance_info'>
                                        <i class="bi bi-info-circle"></i>
                                        <span className='ms-1'>1 SW Wallet Point = 1INR</span>
                                    </div>
                                    <div className='text-center'>
                                        <img src={wallelBalicon} />
                                        <div className='WalletBal'>{walletBalance}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-7'>
                        <div className='walletQuickAccess'>
                            
                            <div className='SwSubHeading pb-2'>
                                <h3>Quick Access</h3>
                            </div>

                            <div className='QuickAccessContainer'>
                                <div className='walletQuickAccessCard' >
                                    <a href='/bank-details'>
                                        <img src={topupWalletIcon} className='QuickAccesCard-icon' />
                                        <div className='walletQuickAccess_Title'>
                                            <span>Top Up Wallet</span>
                                        </div>
                                    </a>
                                </div>

                                <div className='walletQuickAccessCard' >
                                    <a href='/point-distribution'>
                                        <img src={distriIcon} className='QuickAccesCard-icon' />
                                        <div className='walletQuickAccess_Title'>
                                            <span>Distribute</span>
                                        </div>
                                    </a>
                                </div>

                                <div className='walletQuickAccessCard'>
                                    <a href='/redemption-report'>
                                        <img src={redemIcon} className='QuickAccesCard-icon' />
                                        <div className='walletQuickAccess_Title'>
                                            <span>Redemption Report</span>
                                        </div>
                                    </a>
                                </div>

                                <div className='walletQuickAccessCard' >
                                    <a href='/purchase-history'>
                                        <img src={purchaseIcon} className='QuickAccesCard-icon' />
                                        <div className='walletQuickAccess_Title'>
                                            <span>Purchase Report</span>
                                        </div>
                                    </a>
                                </div>

                                <div className='walletQuickAccessCard'>
                                    <a href='/distribution-report'>
                                        <img src={distriHistory} className='QuickAccesCard-icon' />
                                        <div className='walletQuickAccess_Title'>
                                            <span>Distribution Report</span>
                                        </div>
                                    </a>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>




                <section className='WalletPageCTA-Strip'>
                    <div className='WalletPageCTA-Label'>
                        <img src={ctaStripIcon} className='pr-2' />
                        <span>Want to start a new active plan?  Select from these two options :</span>
                    </div>
                    <div className='WalletPageCTA flex-fill'>
                        <a href='topup-wallet' onClick={() => { localStorage.setItem('selectedType', 'Monthly') }}>A - Monthly auto distribution of Points</a>
                    </div>
                    <div className='WalletPageCTA flex-fill'>
                        <a href='topup-wallet' onClick={() => { localStorage.setItem('selectedType', 'AccessBased') }}>B - Access-based distribution of Points</a>
                    </div>
                </section>


                {/* <section className='WalletPageCTA-Strip_B'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='ActivePlan_Status'>
                                <div>
                                    <div className='ActivePlan_Label'>Your Active plan: </div>
                                    <div className='ActivePlan_Data'>Smartworks Monthly scheme</div>
                                </div>
                                <div>
                                    <div className='ActivePlan_Label'>Per top-up </div>
                                    <div className='ActivePlan_Data d-flex'>
                                        <img src={wallelBalicon} width={'12px'} />
                                        <span className='ml-1'>300</span>
                                    </div>
                                </div>
                                <div>
                                    <div className='ActivePlan_Label'>Valid till: </div>
                                    <div className='ActivePlan_Data'>28 / 08 / 2024</div>
                                </div>
                                <a href='#' className='ActivePlan_ViewDetail' data-toggle="modal" data-target="#ActivePlanPopup" data-backdrop="static">View</a>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <section className='WalletPageCTA-Strip'>
                                <div className='WalletPageCTA-Label'>
                                    <img src={ctaStripIcon} className='pr-2' />
                                    <span>Want to start a new active plan?  </span>
                                </div>
                                <div className='WalletPageCTA flex-fill'>
                                    <a href='topup-wallet' onClick={() => { localStorage.setItem('selectedType', 'Monthly') }}>Get a New Plan</a>
                                </div>
                            </section>
                        </div>

                    </div>
                </section> */}


                <section className='RecentsActivitiesSection'>
                    <div className='SwSubHeading pt-4 mt-2'>
                        <h3>Recents Activities</h3>
                    </div>
                    <div className='row no-gutters RecentsActivitiesMainRow'>
                        {/* Top-ups (Purchases) */}
                        <div className='col-md-4'>
                            <div className='RecentsActivities_Container'>
                                <div className='ActivityHeader'>
                                    Top-ups (Purchases)
                                </div>
                                {!spinner ?
                                    topUps && topUps.length > 0 ?
                                        <div className='ActivityDataBox'>
                                            {topUps.map((item, index) => (
                                                <div key={index} className='ActivityData_Row'>
                                                    <div className='Activity_txt'>
                                                        <span> Date: {item.date}</span>
                                                    </div>
                                                    <div className='Act_point d-flex'>
                                                        <img src={wallelBalicon} />
                                                        <span>{item.amount}</span>
                                                    </div>
                                                </div>

                                            ))}
                                            <div className='text-right'>
                                                <SwButton
                                                    variant='dark-outline'
                                                    size='sm'
                                                    onClick={() => navigate("/purchase-history")}
                                                    icon={<i className='bi bi-arrow-right' />}
                                                    iconPosition='end'
                                                >
                                                    View more
                                                </SwButton>
                                            </div>
                                        </div> :
                                        <div className='ActivityDataBox'>
                                            {/* Overlay */}
                                            <div className='GetStartedOverlay'>
                                                <div className='text-center'>
                                                    <img src={LockIcon} />
                                                    <p>Top-up to get started</p>
                                                </div>
                                            </div>

                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='text-right'>
                                                <SwButton
                                                    variant='dark-outline'
                                                    size='sm'
                                                    onClick={() => navigate("/purchase-history")}
                                                    icon={<i className='bi bi-arrow-right' />}
                                                    iconPosition='end'
                                                >
                                                    View more
                                                </SwButton>
                                            </div>
                                        </div>
                                        :  <SwLoader />
                                }
                            </div>
                        </div>

                        {/* Distribution */}
                        <div className='col-md-4'>
                            <div className='RecentsActivities_Container'>
                                <div className='ActivityHeader'>
                                    Distribution
                                </div>
                                {!spinnerDist ?
                                    distribution && distribution.length > 0 ?
                                        <div className='ActivityDataBox'>
                                            {distribution.map((item, index) => (
                                                <div key={index} className='ActivityData_Row'>
                                                    <div className='Activity_txt'>
                                                        <span>{item['Name']}</span>
                                                        <span className='Activity_Date' >Date: {item['Date']}</span>
                                                    </div>
                                                    <div className='Act_point d-flex'>
                                                        <img src={wallelBalicon} />
                                                        <span>{item['Amount']}</span>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className='text-right'>
                                                <SwButton
                                                    variant='dark-outline'
                                                    size='sm'
                                                    onClick={() => navigate("/distribution-report")}
                                                    icon={<i className='bi bi-arrow-right' />}
                                                    iconPosition='end'
                                                >
                                                    View more
                                                </SwButton>
                                            </div>
                                        </div> : <div className='ActivityDataBox'>
                                            <div className='ActivityData_Row'>
                                                {/* Overlay */}
                                                <div className='GetStartedOverlay'>
                                                    <div className='text-center'>
                                                        <img src={LockIcon} />
                                                        <p>Distribute to get started</p>
                                                    </div>
                                                </div>
                                                <div className='Activity_txt'>
                                                    <span>Abhishek Singh</span>
                                                    <span className='Activity_Date' >Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Abhishek Singh</span>
                                                    <span className='Activity_Date' >Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Abhishek Singh</span>
                                                    <span className='Activity_Date' >Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='text-right'>
                                                <SwButton
                                                    variant='dark-outline'
                                                    size='sm'
                                                    onClick={() => navigate("/distribution-report")}
                                                    icon={<i className='bi bi-arrow-right' />}
                                                    iconPosition='end'
                                                >
                                                    View more
                                                </SwButton>
                                            </div>
                                        </div> : <SwLoader />
                                }
                            </div>
                        </div>

                        {/* User redemption */}
                        <div className='col-md-4'>
                            <div className='RecentsActivities_Container'>
                                <div className='ActivityHeader'>
                                    User Redemption
                                </div>
                                {!spinnerUser ?
                                    userRedemption && userRedemption.length > 0 ?
                                        <div className='ActivityDataBox'>
                                            {userRedemption.map((item, index) => (
                                                <div key={index} className='ActivityData_Row'>
                                                    <><div className='Activity_txt'>
                                                        <span>{item['Name']}</span>
                                                        <span className='Activity_Date'>{item['Date']}</span>
                                                    </div>
                                                        <div className='Act_point d-flex'>
                                                            <span className='StoreName'>{item['Vendor']}</span>
                                                            <img src={wallelBalicon} />
                                                            <span>{item['Amount']}</span>
                                                        </div></>

                                                </div>
                                            ))}
                                            <div className='text-right'>
                                                <SwButton
                                                    variant='dark-outline'
                                                    size='sm'
                                                    onClick={() => navigate("/redemption-report")}
                                                    icon={<i className='bi bi-arrow-right' />}
                                                    iconPosition='end'
                                                >
                                                    View more
                                                </SwButton>
                                            </div>
                                        </div> : <div className='ActivityDataBox'>
                                            <div className='ActivityData_Row'>
                                                {/* Overlay */}
                                                <div className='GetStartedOverlay'>
                                                    <div className='text-center'>
                                                        <img src={LockIcon} />
                                                        <p>Unlock to get started</p>
                                                    </div>
                                                </div>
                                                <div className='Activity_txt'>
                                                    <span>Abhishek Singh</span>
                                                    <span className='Activity_Date' >Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <span className='StoreName'>Smartstore</span>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Abhishek Singh</span>
                                                    <span className='Activity_Date' >Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <span className='StoreName'>Smartstore</span>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='ActivityData_Row'>
                                                <div className='Activity_txt'>
                                                    <span>Abhishek Singh</span>
                                                    <span className='Activity_Date' >Date: 16 Feb, 4:04 PM</span>
                                                </div>
                                                <div className='Act_point d-flex'>
                                                    <span className='StoreName'>Smartstore</span>
                                                    <img src={wallelBalicon} />
                                                    <span>57000</span>
                                                </div>
                                            </div>
                                            <div className='text-right'>
                                                <SwButton
                                                    variant='dark-outline'
                                                    size='sm'
                                                    onClick={() => navigate("/redemption-report")}
                                                    icon={<i className='bi bi-arrow-right' />}
                                                    iconPosition='end'
                                                >
                                                    View more
                                                </SwButton>
                                            </div>
                                        </div> : <SwLoader />
                                    }
                            </div>
                        </div>

                    </div>
                </section>
            </div>


            {/* Active Plan Modal */}
            {/* <div class="modal ActivePlanPopup fade" id="ActivePlanPopup" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div className='ActivePlanPopup_Title'>
                                <h2>Your <br />Active Wallet Plan</h2>
                                <img src={ActivePlanPopupimg} />
                            </div>
                            <div className='ActivePlanPopup_Data'>
                                <div className='ActivePlanPopup_DataRow'>
                                    <div className='ActivePlanlabel'>Name:</div>
                                    <div className='ActivePlanValue'><span>Smartworks Monthly Scheme</span></div>
                                </div>
                                <div className='ActivePlanPopup_DataRow'>
                                    <div className='ActivePlanlabel'>Type of plan:</div>
                                    <div className='ActivePlanValue'><span>Monthly Top-up plan</span></div>
                                </div>
                                <div className='ActivePlanPopup_DataRow'>
                                    <div className='ActivePlanlabel'>Total amount distributed:</div>
                                    <div className='ActivePlanValue'>
                                        <img src={wallelBalicon} width={'12px'} />
                                        <span>57000</span>
                                    </div>
                                </div>
                                <div className='ActivePlanPopup_DataRow'>
                                    <div className='ActivePlanlabel'>Per Top-up</div>
                                    <div className='ActivePlanValue'>
                                        <img src={wallelBalicon} width={'12px'} />
                                        <span>400</span>
                                    </div>
                                </div>
                                <div className='ActivePlanPopup_DataRow'>
                                    <div className='ActivePlanlabel'>Start Date</div>
                                    <div className='ActivePlanValue'><span>28/03/2024 </span></div>
                                </div>
                                <div className='ActivePlanPopup_DataRow'>
                                    <div className='ActivePlanlabel'>End Date</div>
                                    <div className='ActivePlanValue'><span>23/04/2024</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-dark " data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div> */}


        </div>
           </Layout>
                
                </Layout>
    </>)
}
export default CompanyWallet